declare global {
  interface Window {
    ymaps?: any;
  }
}

let yandexMapsPromise: Promise<any> | null = null;
let yandexMapsUnavailable = false;

export function getYandexMapsApiKey() {
  return String(import.meta.env.VITE_YANDEX_MAP_KEY || "").trim();
}

export function isYandexMapsUnavailable() {
  return yandexMapsUnavailable;
}

export function loadYandexMaps(lang = "ru_RU") {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Yandex Maps can only load in browser"));
  }

  if (yandexMapsUnavailable) {
    return Promise.reject(new Error("Yandex Maps unavailable"));
  }

  if (window.ymaps?.Map) {
    return Promise.resolve(window.ymaps);
  }

  if (yandexMapsPromise) {
    return yandexMapsPromise;
  }

  yandexMapsPromise = new Promise((resolve, reject) => {
    const fail = (error: Error) => {
      yandexMapsUnavailable = true;
      yandexMapsPromise = null;
      const existing = document.querySelector(
        'script[data-lyke-yandex-maps="1"]',
      );
      existing?.remove();
      reject(error);
    };

    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-lyke-yandex-maps="1"]',
    );

    const onReady = () => {
      if (!window.ymaps) {
        fail(new Error("Yandex Maps failed to initialize"));
        return;
      }
      window.ymaps.ready(() => resolve(window.ymaps));
    };

    const timeoutId = window.setTimeout(() => {
      fail(new Error("Yandex Maps load timeout"));
    }, 8000);

    const clearTimer = () => window.clearTimeout(timeoutId);

    if (existing) {
      if (window.ymaps) {
        clearTimer();
        onReady();
      } else {
        existing.addEventListener(
          "load",
          () => {
            clearTimer();
            onReady();
          },
          { once: true },
        );
        existing.addEventListener(
          "error",
          () => {
            clearTimer();
            fail(new Error("Failed to load Yandex Maps script"));
          },
          { once: true },
        );
      }
      return;
    }

    const key = getYandexMapsApiKey();
    const params = new URLSearchParams({
      lang,
      load: "package.full",
    });
    if (key) {
      params.set("apikey", key);
    }

    const script = document.createElement("script");
    script.src = `https://api-maps.yandex.ru/2.1/?${params.toString()}`;
    script.async = true;
    script.dataset.lykeYandexMaps = "1";
    script.onload = () => {
      clearTimer();
      onReady();
    };
    script.onerror = () => {
      clearTimer();
      fail(new Error("Failed to load Yandex Maps script"));
    };
    document.head.appendChild(script);
  });

  return yandexMapsPromise;
}
